import { AddressEndpoints } from "@ADDRESS";
import { useGET } from "@API2";
import { Select } from "antd";
import { useEffect, useState } from "react";
import { URLify } from "@HELPERS";

const { Option } = Select;

const Towns = (props) => {
  const [deliveryTypeState, setDeliveryTypeState] = useState(null);
  const { deliveryType } = props;
  const { data = [], loading } = useGET(
    `${AddressEndpoints.towns}?cityId=${props.cityId?.id}&deliveryType=${
      deliveryTypeState ? deliveryTypeState : ""
    }`,
    props.cityId?.id && deliveryTypeState === deliveryType ? true : false
  );
  const [val, setVal] = useState(
    typeof props?.value === "object" ? props?.value?.id : null
  );

  useEffect(() => {
    if (deliveryType && deliveryTypeState !== deliveryType) {
      setDeliveryTypeState(deliveryType);
    }
  }, [deliveryType]);

  useEffect(() => {
    if (!loading) {
      const isSelectedExist = data.find((x) => x.id === val);
      if (!isSelectedExist && val !== null && data.length > 0) {
        props.onChange({ id: null, name: null });
        setVal(null);
        if (props.form) {
          props.form.setFieldsValue({
            [props.fieldName]: { recipientDistrict: null, recipientTown: null },
          });
        }
      }
      // eğer excelden geliyorsa string gelecek. onu data içerisinde bulup, seçtiriyoruz.
      // urlify ÇANKAYA gibi gelen bir datayı cankaya şekline dönüştürür. Böylece match etmesi kolaylaşır.
      if (typeof props.value === "string") {
        const that = data.find((x) => URLify(x.name) === URLify(props.value));
        if (that) {
          setVal(that.id);
          props.onChange({ id: that.id, name: that.name });
        }
      }

      if (!props.value) {
        setVal(null);
      }
    }
  }, [props, loading]);

  if (loading) {
    return <Select disabled loading placeholder="Yükleniyor..." />;
  }

  return (
    <Select
      onChange={(v) => {
        const current = data.find((x) => x.id === v);
        props.onChange({ id: current.id, name: current.name, forced: true });
        setVal(current.id);
      }}
      loading={loading}
      showSearch
      value={val}
      disabled={props.disabled || false}
      filterOption={(input, option) =>
        option.name.indexOf(input.toLocaleLowerCase("tr")) >= 0
      }
    >
      {data.map((item) => (
        <Option
          key={item.id}
          value={item.id}
          name={item.name.toLocaleLowerCase("tr")}
        >
          {item.name}
        </Option>
      ))}
    </Select>
  );
};

export default Towns;
